import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationChangeNotification from 'bento-ordering/base/components/LocationChangeNotification';

import { handleLocationSwitch } from 'bento-ordering/base/actions/notificationModals';

class LocationChangeNotificationContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    onlineOrderingLocation: PropTypes.number,
    onlineOrderingFulfillmentMethod: PropTypes.string
  };

  handlePrimaryCta = () => {
    this.props.dispatch(
      handleLocationSwitch(
        this.props.onlineOrderingLocation,
        this.props.onlineOrderingFulfillmentMethod
      )
    );
  };

  render() {
    const { closeModal } = this.props;
    return (
      <LocationChangeNotification
        handlePrimaryCta={this.handlePrimaryCta}
        closeModal={closeModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  onlineOrderingLocation:
    state.notificationModal.modalProps.onlineOrderingLocation,
  onlineOrderingFulfillmentMethod: state.cart.online_ordering_fulfillment_method
});

export default connect(mapStateToProps)(LocationChangeNotificationContainer);
